export default "__VITE_ASSET__BxF3hL0w__"